let runtimeConfig = {};

export async function loadConfig() {
  const response = await fetch("/runtime-config.json");
  runtimeConfig = await response.json();
}

// Get config value with optional fallback
export function getConfig(key, fallback) {
  return runtimeConfig[key] ?? fallback;
}

// Use runtime config first, fallback only if missing
export const getBaseURL = () => {
  return getConfig("REACT_APP_BASE_URL", "https://quest-share.com/");
};

export const getWebRtcURL = () => {
  return getConfig("REACT_APP_WEB_RTC_URL", "https://quest-share.com/");
};
